<template>
    <div @keydown.enter="codeSent ? submitForm() : sendCode()">
        <div class="form-group">
            <Input
                :inputClass="form.phone.inputClass"
                :isValid="form.phone.required ? form.phone.isValid : true"
                :validationMessage="form.phone.required ? form.phone.validationMessage : ''"
                :type="form.phone.type"
                :name="Object.keys(form)[0]"
                :label="form.phone.label"
                :labelDescription="form.phone.labelDescription"
                :required="form.phone.required"
                :cleaveOptions="form.phone.cleaveOptions"
                v-model="form.phone.value"
                :suggestion="form.phone.suggestion"
                :mask="form.phone.mask"
                :disabled="codeSent" />
        </div>
        <div class="form-group">
            <Input
                :inputClass="form.code.inputClass"
                :isValid="form.code.required ? form.code.isValid : true"
                :validationMessage="form.code.required ? form.code.validationMessage : ''"
                :type="form.code.type"
                :name="Object.keys(form)[1]"
                :label="form.code.label"
                :labelDescription="form.code.labelDescription"
                :required="form.code.required"
                :cleaveOptions="form.code.cleaveOptions"
                v-model="form.code.value"
                :suggestion="form.code.suggestion"
                :mask="form.code.mask"
                v-if="codeSent"
                :autocomplete="true" />
        </div>
        <transition name="fade">
            <div class="error text_11" v-if="error">{{ error }}</div>
        </transition>
        <div class="form-group form-group--margin text_11" v-if="codeSent && timerCount > 0">
            {{ $t("lk_send_code_timer") }} {{ timerCount }} {{ $t("lk_send_code_timer_seconds") }}
        </div>
        <div class="button button--text text_13" v-if="codeSent && timerCount === 0" @click="sendCode">
            {{ $t("lk_send_code_again") }}
        </div>
        <div class="form-group login-submit">
            <div v-if="!codeSent" class="button button--dark button--wide" @click="sendCode">
                {{ $t("lk_send_code") }}
            </div>
            <div v-if="codeSent" class="button button--dark button--wide" @click="submitForm">
                {{ $t("lk_log_in") }}
            </div>
            <nuxt-link :to="{ name: 'lk-register', query: $route.query }" class="button button--text">{{
                $t("lk_register")
            }}</nuxt-link>
        </div>
    </div>
</template>

<script>
import Input from "@/components/form/Input.vue";
import { createRetailCRM } from "../plugins/retailCRM.client";
export default {
    name: "LoginByPhone",
    components: { Input },
    data() {
        return {
            error: "",
            form: {
                phone: {
                    label: this.$i18n.t("phone"),
                    type: "tel2",
                    required: true,
                    isValid: true,
                    validationMessage: "",
                    value:
                        this.$auth.loggedIn && this.$auth.user.phone
                            ? this.$auth.user.phone
                            : this.currentCountryPhoneCode,
                    inputClass: "black-border",
                    mask: "+7 (###) ###-##-##",
                },
                code: {
                    label: this.$i18n.t("sms_code"),
                    type: "text",
                    required: true,
                    isValid: true,
                    validationMessage: "",
                    value: null,
                    inputClass: "black-border",
                    mask: "####",
                },
            },
            activeLoginType: "email",
            codeSent: false,
            timerCount: 60,
        };
    },
    watch: {
        langust() {
            this.form.phone.label = this.$i18n.t("phone");
            this.form.code.label = this.$i18n.t("sms_code");
        },
    },
    methods: {
        processError(error) {
            this.isLoading = false;
            if (error.response) {
                if (error.response.status == 406) {
                    let notValidFields = error.response.data.data;
                    for (const key in notValidFields) {
                        if (notValidFields.hasOwnProperty(key)) {
                            const element = notValidFields[key];
                            let name = key.split(".").length > 1 ? key.split(".")[1] : key;
                            if (this.form[name]) {
                                this.form[name].isValid = false;
                                this.form[name].validationMessage = Array.isArray(element) ? element[0] : element;
                            }
                        }
                    }
                    let first_key = Object.keys(notValidFields)[0];
                    let first_name = first_key.split(".").length > 1 ? first_key.split(".")[1] : first_key;
                    let elem = document.querySelector(`[name="${first_name}"]`);
                    if (elem) {
                        elem.scrollIntoView({ block: "center", behavior: "smooth" });
                        elem.focus();
                    }
                } else {
                    console.log(`error.response.error =>`, error.response.error);
                    if (error.response.data.error) {
                        this.error = error.response.data.error;
                    } else {
                        this.error = error;
                    }
                }
            }
        },
        sendCode() {
            this.error = "";
            for (const key in this.form) {
                if (Object.hasOwnProperty.call(this.form, key)) {
                    const element = this.form[key];
                    element.isValid = true;
                    element.validationMessage = "";
                }
            }

            this.$axios
                .post("api/auth/send_code", { phone: this.form.phone.value })
                .then(() => {
                    this.codeSent = true;
                    this.timerCount = 60;
                    this.timer();
                })
                .catch((error) => {
                    this.processError(error);
                });
        },
        submitForm() {
            this.error = "";
            for (const key in this.form) {
                if (Object.hasOwnProperty.call(this.form, key)) {
                    const element = this.form[key];
                    element.isValid = true;
                    element.validationMessage = "";
                }
            }

            this.$auth
                .loginWith("cookie", {
                    data: { phone: this.form.phone.value, code: this.form.code.value },
                })
                .then((res) => {
                    if (res.data.success) {
                        this.$gtm.push({
                            event: "GAevent",
                            eventCategory: "user",
                            eventAction: "send",
                            eventLabel: "entrance",
                            userId: res.data.data.retail_id,
                        });

                        createRetailCRM(this.$auth.user?.retail_id || null, this.$auth.user.name);
                        this.$grom.checkEverCookie();

                        // if (this.$route.query.redirect === "zakaz") {
                        //     this.$router.push("/zakaz");
                        // } else {
                        //     this.$router.push("/lk");
                        // }
                    } else {
                        this.error = res.data.error;
                        this.processError(this.error);
                    }
                })
                .catch((error) => {
                    this.processError(error);
                });
        },
        timer() {
            if (this.timerCount > 0) {
                setTimeout(() => {
                    this.timerCount--;
                    this.timer();
                }, 1000);
            }
        },
    },
};
</script>

<style scoped></style>
